<template>
    <div>
        <hts-form-select
            v-model="cValue"
            v-model:text="cText"
            :query="findNode"
            :filterable="true"
            :clearable="true"
            :label="label"
            :required="required"
            :disabled="disabled"
            :multiple="multiple"
            :selected-multiple="selectedMultiple"
            :prop="prop"
            :name="name"
            key-id="_id"
            :key-label="keyLabel"
            :param-prepare="paramPrepare"
            @change="handleChange" />
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  modelValue: { type: [Array, String], default: () => '' },
  label: { type: String, default: () => $t('labels.parkingLot') },
  prop: { type: String },
  name: { type: String },
  text: { type: String, default: '' },
  multiple: { type: Boolean, default: false },
  selectedMultiple: { type: Array },
  disabled: { type: Boolean, default: false },
  required: { type: Boolean, default: false },
  keyLabel: {
    type: String,
    default: 'locationName'
  },
  keyId: {
    type: String,
    default: '_id'
  },
  paramPrepare: {
    type: String,
    default: ''
  }
})

const type = 'PARKING'

const { modelValue, text } = toRefs(props)

const information = ref([])
const emits = defineEmits(['update:modelValue', 'update:text', 'update', 'change'])

const cText = computed({
  get () {
    return text.value
  },
  set (val: any) {
    emits('update:text', val)
  }
})

const cValue = computed({
  get () {
    return modelValue.value
  },
  set (val: any) {
    emits('update:modelValue', val)
  }
})

const findNode = async (s: string) => {
  const api = $urlAdmin.node.findNodes

  const res = await $api(api, { uriParams: { KEY: s, NODETYPE: type } })
  const resData: any = res?.data.value
  if (resData?.success) {
    return resData.data
  }
  return null
}
const handleChange = (val: any) => {
  emits('change', val)
}
</script>
